import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import th from './locales/th.json'
import en from './locales/en.json'
import lo from './locales/lo.json'
import km from './locales/km.json'

const resources = {
  th: { translation: th },
  en: { translation: en },
  lo: { translation: lo },
  km: { translation: km },
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'th', // default language
    fallbackLng: 'th',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n















